import { ovl, SYSAction } from "../../../../../_ovlclient/src"
import { HookFormValidate_Type } from "../../../../../_ovlclient/src/global/hooks"

import {
  FieldCurrentVal,
  FieldIsValid,
  SYSField,
  SYSFormState,
} from "../../../../../_ovlclient/src/library/forms/fieldapi"
import { ValidationsAdd } from "../../../../src/library/forms/validatorsapi"

const HookFormValidate: SYSAction<HookFormValidate_Type> = (
  value,
  { global }
) => {
  let state = global.getState()
  switch (value.field.fieldKey) {
    case "pw":
      value.validatorUse("Mandatory")
      break
    case "pw1":
      if (
        value.validatorUse("Regex", {
          val: {
            val: state.ovl.app.pwRegex,
            msg: "SYSPasswordPolicy",
          },
        })
      ) {
        pwNotTheSameLikeOldOne(value.formState)
        if (FieldIsValid(value.formState.fields.pw2)) {
          pwFieldsTheSame(value.field, value.formState.fields.pw2)
        }
      }

      break
    case "pw2":
      if (
        !state.ovl.app.enablePasswordVisibility &&
        value.validatorUse("Regex", {
          val: {
            val: state.ovl.app.pwRegex,
            msg: "SYSPasswordPolicy",
          },
        }) &&
        FieldIsValid(value.formState.fields.pw1)
      ) {
        pwNotTheSameLikeOldOne(value.formState)
        pwFieldsTheSame(value.field, value.formState.fields.pw1)
      }
      break
  }
}

const pwNotTheSameLikeOldOne = (formState: SYSFormState) => {
  if (
    FieldCurrentVal(formState.fields.pw1) ===
    FieldCurrentVal(formState.fields.pw)
  ) {
    ValidationsAdd(
      [formState.fields.pw, formState.fields.pw1],
      "SYSLandingPage01ValidationNewPasswordConfirmation",
      "Validate",
      {
        validation: {
          displayType: "OnlyOutline",
        },
      }
    )
  }
}

const pwFieldsTheSame = (field: SYSField, fieldToCompare: SYSField) => {
  if (ovl.getState().ovl.app.enablePasswordVisibility) {
    return
  }
  if (FieldCurrentVal(field) !== FieldCurrentVal(fieldToCompare)) {
    ValidationsAdd(
      [field, fieldToCompare],

      "SYSLandingPage01ValidationNewPasswordConfirmation",
      "Validate",
      {
        validation: {
          displayType: "OnlyOutline",
          summaryGroup: "ValidationKey",
        },
      }
    )
  }
}

export let hooks = { HookFormValidate /*, HookFormAutoInit*/ }
